import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  getCurrentPosition() {
    const options = {
      timeout: 10000, // 10 seconds timeout
      maximumAge: 0,
      enableHighAccuracy: true
    };

    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(resolve, (error) => {
          reject(error);
        }, options);
      } else {
        reject(new Error('Geolocation is not supported by this browser.'));
      }
    });
  }
}
